import React from 'react';
import PropTypes from 'prop-types';

const Container = ({ id, children }) => (
  <div className="shape grid__bit -w3-tablet" id={`shape_${id}`}>
    {children}
  </div>
);

Container.propTypes = {
  id: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

Container.defaultProps = {
  id: null,
};

export default Container;
